
import { useEffect, useState } from 'react'
import './style.scss'
import '../styles/admintab.scss'
import { useAppSelector } from '../../redux/hooks'
import { UserData } from '../../server/types'
import { getProfilePicPath } from '../../constants/instructorConstants'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { adminStateData } from '../../data/adminStateData'
import { AccountStatus } from '../../types/types'

function AdminCustomersContentArea() {
	const [tabIndex, setTabIndex] = useState<number>(0)
	const [customers, setCustomers] = useState<UserData[]>([])
	const [adminDataLoaded, setAdminDataLoaded] = useState<boolean>(false)

	const dataLoadRequestFinished: boolean = useAppSelector(state => state.user.dataLoadRequestFinished)

	const INSTRUCTOR_TABS: string[] = ['All', 'Flagged', 'Banned', 'Disabled']
	const TAB_STATUSES: string[] = ['', AccountStatus.FLAGGED, AccountStatus.BANNED, AccountStatus.DISABLED]

	useEffect(() => {
		if (dataLoadRequestFinished === true) {
			setAdminDataLoaded(true)
			setCustomers(adminStateData.getCustomers())
			setTabIndex(0)
		}
	}, [dataLoadRequestFinished])

	const tabClickHandler = (newIndex: number) => {
		if (newIndex === 0) {
			setCustomers(adminStateData.getCustomers())
		} else {
			setCustomers(adminStateData.getCustomersWithStatus(TAB_STATUSES[newIndex]))
		}
		setTabIndex(newIndex)
	}

	return (
		<div className='dashboard-content-area-wrap'>
			{adminDataLoaded &&
				<div className='dashboard-content-area-wide-card-wrap'>
					<div className='dashboard-content-area-card'>
					<div className='admin-tab-wrap'>
							{INSTRUCTOR_TABS.map((tab: string, index: number) => 
								<div 
									className={`admin-tab-item ${tabIndex === index ? 'admin-tab-item-active' : ''}`}
									key={`tablabel${index}`}
									onClick={() => tabClickHandler(index)}
								>{tab}</div>
							)}
						</div>
						<div
							className='dashboard-content-area-card-content'
						>
							{
							customers.length === 0 ?
								<span>No Flagged Customers</span>
								:
								customers.map((customer: UserData, index: number) => 
									<a 
										className='dashboard-user-list-wrap'
										key={`customerItem${index}`}
										href={`${PAGE_URLS.ADMIN_CUSTOMER}?id=${customer.id}`}
									>
										<img
											className='dashboard-user-list-img'
											alt='profile thumbnail'
											src={customer?.profile_pics ? getProfilePicPath(customer?.profile_pics, 0) : undefined}
										/>
										<div className='dashboard-user-list-details-wrap'>
											<div className='dashboard-user-list-name'>{customer?.name}</div>
											<div className='dashboard-user-list-extract'>{customer?.email}</div>
										</div>
										{customer?.status === 'FLAGGED' &&
											<div className='dashboard-admin-status dashboard-admin-status-flagged'>Flagged</div>
										}
									</a>
								)
							}
						</div>
					</div>
				</div>
			}
		</div>
	)
}

export default AdminCustomersContentArea
